export default __webpack_public_path__ + "static/media/loginPage.a4da9d63.png";